import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	card: {
		cursor: 'pointer',
		borderRadius: theme.radius.sm,
		padding: `${theme.spacing.xs} ${theme.spacing.md} ${theme.spacing.xs} ${theme.spacing.sm}`,
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/primary/hover'),
		},
		'&:active': {
			backgroundColor: theme.other.getColor('surface/primary/active'),
		},
	},
	avatarInfo: {
		flex: 1,
		minWidth: 0,
	},
}));
